import type { ApiRequestParam, ApiType } from "@gameApp/api/types";
import {
  DPS_API_BASE_URL,
  EBI_API_BASE_URL,
  EBI_API_KEY,
  PUBLIC_API_BASE_URL,
  SWS_API_BASE_URL,
} from "@gameApp/constants";
import WebApp from "@twa-dev/sdk";

export const API_REQUEST_PARAMS: Record<ApiType, ApiRequestParam> = {
  EBI: {
    baseUrl: EBI_API_BASE_URL,
    options: {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "X-MBX-APIKEY": EBI_API_KEY,
        Accept: "application/json",
      },
    },
  },
  DPS: {
    baseUrl: DPS_API_BASE_URL,
    options: {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        "X-TG-DATA": WebApp.initData,
      },
    },
  },
  SWS: {
    baseUrl: SWS_API_BASE_URL,
    options: {
      method: "GET",
    },
  },
  PUBLIC: {
    baseUrl: PUBLIC_API_BASE_URL,
    options: {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    },
  },
};
